export const FLAG_GETTING_FREE_OF_CHARGE_CATEGORIES =
  'FLAG_GETTING_FREE_OF_CHARGE_CATEGORIES';
export const GET_FREE_OF_CHARGE_CATEGORIES = 'GET_FREE_OF_CHARGE_CATEGORIES';
export const CLEAR_FREE_OF_CHARGE_CATEGORIES =
  'CLEAR_FREE_OF_CHARGE_CATEGORIES';
export const GET_FREE_OF_CHARGE_CATEGORY = 'GET_FREE_OF_CHARGE_CATEGORY';
export const CLEAR_FREE_OF_CHARGE_CATEGORY = 'CLEAR_FREE_OF_CHARGE_CATEGORY';
export const FLAG_FREE_OF_CHARGE_CATEGORY_ACTIVITY =
  'FLAG_FREE_OF_CHARGE_CATEGORY_ACTIVITY';
